import { DEFAULT_PAGE_SIZE } from '@/lib/constants/pagination';
import { DropdownSearchItem } from '@/modules/common/components/molecules/selectors/dropdown';
import { PaginatedResponse } from '@/modules/common/types/pagination-types';

import { getShortTeamMembers } from '../api/team.api';
import { NON_ARCHIVED_TEAM_MEMBER_STATUSES } from '../types/dto/find-short-team-members.request';

/**
 * Hook providing data loading functions for team member info selectors
 * (managers with pagination support)
 */
export function useTeamMemberSelectors() {
  /**
   * Load managers for selector with pagination
   */
  const loadManagers = async (
    cursor?: number | null
  ): Promise<PaginatedResponse<DropdownSearchItem>> => {
    return getShortTeamMembers({
      filter: { isManager: true, statuses: NON_ARCHIVED_TEAM_MEMBER_STATUSES },
      pagination: { cursor, pageSize: DEFAULT_PAGE_SIZE },
    });
  };

  /**
   * Search managers for selector with pagination
   */
  const searchManagers = async (
    searchTerm: string,
    cursor?: number | null
  ): Promise<PaginatedResponse<DropdownSearchItem>> => {
    return getShortTeamMembers({
      filter: {
        searchString: searchTerm,
        isManager: true,
        statuses: NON_ARCHIVED_TEAM_MEMBER_STATUSES,
      },
      pagination: { cursor, pageSize: DEFAULT_PAGE_SIZE },
    });
  };

  return {
    loadManagers,
    searchManagers,
  };
}
